import React from 'react';
import { useDispatch } from 'react-redux';
import { fetchSettings } from '../../../store/modules/reportdailytransactions/reportdailytransactionsActions';
import useFormSettings from '../../../hooks/useFormSettings';

const ReportDailyTransactionForm = ({ initialData, onSave, isLoading, onClose }) => {
    const { settings, isLoadingSettings, isSettingsInitialized } = useFormSettings('reportdailytransactions', fetchSettings);
    const dispatch = useDispatch();

    return null;
};

export default ReportDailyTransactionForm;